import { calculateFontSize, calculateLineHeight, useChapterSettings } from '@app/components/chapters/hooks';
import LipsumPlaceholder from '@app/components/lipsum.placeholder';

export default function ChapterPlaceholder() {
    const [settings] = useChapterSettings();

    return (
        <LipsumPlaceholder
            containerClassName="mt-[24px] w-full relative"
            className="rounded-none bg-[#e9e9e9] bg-gradient-to-r from-[#f1f1f1] to-[#e9e9e9] dark:bg-[#2a2a2a] dark:from-[#333] dark:to-[#2a2a2a]"
            item={false}
            fontSize={calculateFontSize(settings.fontSizeStep)}
            lineHeight={calculateLineHeight(settings.lineHeightStep)}
        ></LipsumPlaceholder>
    );
}
